import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

type AnyRecord = Record<string, unknown>;

function getNestedValue(source: unknown, dottedKey: string): unknown {
    if (!source || typeof source !== 'object') {
        return undefined;
    }

    return dottedKey
        .split('.')
        .reduce<unknown>(
            (acc, part) =>
                acc && typeof acc === 'object'
                    ? (acc as AnyRecord)[part]
                    : undefined,
            source,
        );
}

export function useTranslations() {
    const page = usePage();

    const locale = computed(() =>
        typeof page.props.locale === 'string' ? page.props.locale : 'en',
    );

    const t = (key: string, fallback?: string): string => {
        const value = getNestedValue(page.props.translations, key);

        return typeof value === 'string' ? value : (fallback ?? key);
    };

    const tList = (key: string, fallback: string[] = []): string[] => {
        const value = getNestedValue(page.props.translations, key);

        return Array.isArray(value)
            ? value.filter((item): item is string => typeof item === 'string')
            : fallback;
    };

    return { locale, t, tList };
}
